<template>
  <footer class="py-3 footer">
    <div class="container">
      <div class="row">
        <div class="mx-auto mb-4 text-center col-lg-8">
          <a
            href=""
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            Contáctenos
          </a>
          <a
            href=""
            target="_blank"
            class="mb-2 text-secondary ms-5 me-0 mb-sm-0"
          >
            Sobre Nosotros
          </a>

        </div>

        <div class="mx-auto mt-2 mb-4 text-center col-lg-8">
          <a
            href=""
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-facebook"></span>
          </a>
          <a
            href=""
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
          <span class="text-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
              <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
            </svg>
          </span>
          </a>
          <a
            href=""
            target="_blank"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-instagram"></span>
          </a>
          <a
            href=""
            target="_blank"
            class="text-secondary"
          >
            <span class="text-lg fab fa-youtube"></span>
          </a>
        
        </div>
      </div>
      <div class="row">
        <div class="mx-auto mt-1 text-center col-8">
          <p class="mb-0 text-secondary">
            Copyright © {{ new Date().getFullYear() }} - Nimbus. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
